module.exports = __webpack_public_path__ + "img/ayuda-verificacion-3.7363c153.png";